import { useMemo } from 'react';
import { getCartPrices, getOrderPrices, getProductPrices } from '../utils/prices';

export default function usePrice({ variation, product, quantity = null, cart, order, deps = [] }) {
    // PRODUCT PRICES
    const productPrice = useMemo(
        () => getProductPrices({ variation, product, quantity }),
        [
            variation?.id,
            product?.id,
            product?.min_base_gross_price,
            product?.min_discounted_gross_price,
            product?.company_special_price,
            quantity,
            ...deps,
        ]
    );

    // CART PRICES
    const cartPrice = useMemo(() => getCartPrices(cart), [cart, ...deps]);

    // ORDER PRICES
    const orderPrice = useMemo(() => getOrderPrices(order), [order, ...deps]);

    return {
        productPrice,
        cartPrice,
        orderPrice,
    };
}
